import React from "react";
import { oilComparison } from "@/data/specials";

/**
 * Responsive oil-tier comparison.
 * Desktop/tablet: HTML table.
 * Mobile (<768px): stacked cards — one block per tier.
 */
export default function OilComparisonTable() {
  const { tiers, highlightIndex, rows } = oilComparison;

  return (
    <div className="oil-compare" data-testid="oil-comparison">
      {/* Desktop / tablet table */}
      <table className="oil-compare-table" role="table" aria-label="Oil change tier comparison">
        <thead>
          <tr>
            <th scope="col">Feature</th>
            {tiers.map((t, i) => (
              <th key={t} scope="col" className={i === highlightIndex ? "oil-compare-highlight" : ""}>
                {t}
                {i === highlightIndex && <span className="oil-compare-tag">Most Popular</span>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.label}>
              <th scope="row">{row.label}</th>
              {row.values.map((v, i) => (
                <td key={i} className={i === highlightIndex ? "oil-compare-highlight" : ""}>
                  {v}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile stacked cards */}
      <div className="oil-compare-stacked" role="list">
        {tiers.map((tier, tIdx) => (
          <div
            key={tier}
            role="listitem"
            className={`oil-compare-card ${tIdx === highlightIndex ? "highlight" : ""}`}
          >
            <div className="oil-compare-card-head">
              <h4>{tier}</h4>
              {tIdx === highlightIndex && <span className="oil-compare-tag">Most Popular</span>}
            </div>
            <dl>
              {rows.map((row) => (
                <div key={row.label} className="oil-compare-row">
                  <dt>{row.label}</dt>
                  <dd>{row.values[tIdx]}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </div>
  );
}
